/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import './dashCard.css';
import {
	setSelectedSection,
	setTab
} from '../../../redux/actions/sideBarAction';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import LoadingRectanglesAnimation from '../../Utils/LoadingAnimations/LoadingRectanglesAnimation';
import { globalEnv } from '../../../config/baseConfig';
import { DataNotFoundAnimation } from '../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../Utils/LoadingAnimations/loadingAnimation';
import Pagination from '../../Utils/Pagination';
import axiosInstance from '../../../config/axiosInstance';
import TopicCard from '../../SubSections/Topic/topicCard';

const queryClient = new QueryClient();

export default function MainDashboard() {
	const { user }: any = useTypedSelector((state) => state.auth);
	const dispatch = useDispatch();
	dispatch(setSelectedSection('Main Dashboard'));

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	dispatch(setTab('main-dashboard'));

	return (
		<QueryClientProvider client={queryClient}>
			<div className="pt-16 h-screen">
				<MainDashboardDetails ACCESS_TOKEN={ACCESS_TOKEN} />
			</div>
		</QueryClientProvider>
	);
}

type UserDetailsProps = {
	ACCESS_TOKEN: string;
};

function MainDashboardDetails({ ACCESS_TOKEN }: UserDetailsProps) {
	const [username, setUsername] = useState('');
	const [email, setEmail] = useState('');
	const [photo, setPhoto] = useState(null);
	const [createdTopics, setCreatedTopics] = useState<any[]>([]);

	const [isShowingContributedTopics, setIsShowingContributedTopics] =
		useState(false);

	const [reloadCount, setReloadCount] = useState(0);

	const [searchParams, setSearchParams] = useSearchParams();
	const urlPage = searchParams.get('page');
	const [page, setPage] = useState(
		urlPage != null && !isNaN(parseInt(urlPage)) ? parseInt(urlPage) : 1
	);

	const { user }: any = useTypedSelector((state) => state.auth);

	const [userId, setUserId] = useState(user._id);

	// handleResize() & dimensions are added to update the dashboard card text size when resizing the window
	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (page != null) {
			if (page === 1) {
				searchParams.delete('page');
				setSearchParams(searchParams);
			} else
				history.pushState(history.state, 'main-dashboard', `?page=${page}`);
		}
	}, [page]);

	async function fetchUserData(id: string) {
		let endpoint = `/editor/${id}/get-details?page=${page}`;
		if (isShowingContributedTopics)
			endpoint = `/topic/get-editor-contributed-topics?page=${page}`;
		const { data } = await axiosInstance().get(
			`${globalEnv.BASE_URL}${endpoint}`
		);
		if (data.meta.pages < page) {
			setPage(1);
		}
		return data;
	}

	const { data, isLoading, isFetching, isError, isSuccess } = useQuery(
		['topics', page, reloadCount, isShowingContributedTopics],
		() => fetchUserData(user._id),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000
		}
	);

	useEffect(() => {
		try {
			if (isShowingContributedTopics) {
				if (data.topics != null) setCreatedTopics(data.topics);
			} else {
				if (data.createdTopics != null)
					setCreatedTopics(data.createdTopics.topics);
			}
		} catch (e) {
			console.log("Editor doesn't have any created or contributed topics");
		}
	}, [data]);

	const navigate = useNavigate();

	return (
		<Scrollbars autoHide>
			<div className="w-12/12 h-16 flex flex-row mx-auto">
				<button
					type="button"
					className="relative w-full py-2.5 px-5 mb-2 text-lg font-bold text-gray-900 
														border-t border-r border-gray-200  hover:text-purple-700 dark:text-gray-400
													dark:border-gray-600 dark:hover:text-white"
					onClick={() => {
						setIsShowingContributedTopics(false);
						setPage(1);
					}}
				>
					<div
						className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${!isShowingContributedTopics && 'opacity-80'}`}
					/>
					Created Topics
				</button>
				<button
					type="button"
					className="relative w-full py-2.5 px-5 mb-2 text-lg font-bold text-gray-900 
														border-t border-r border-gray-200 hover:text-purple-700 dark:text-gray-400
														dark:border-gray-600 dark:hover:text-white"
					onClick={() => {
						setIsShowingContributedTopics(true);
						setPage(1);
					}}
				>
					<div
						className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0 
													hover:opacity-100 transition-all duration-500 text-center
													${isShowingContributedTopics && 'opacity-80'}`}
					/>
					Contributions
				</button>
			</div>
			{isLoading ? (
				<LoadingAnimComponent />
			) : isError ? (
				<div className="h-full ml-18 ">
					<div className=" flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
						<div className="mx-auto my-auto self-center">
							<div className="min-h-16">
								<DataNotFoundAnimation height={dimensions.height / 1.5} />
							</div>
							<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
								{"Couldn't find the data you're looking for!"}
							</h3>
						</div>
					</div>
				</div>
			) : (
				<main className="ml-16 flex flex-col ">
					<section className="relative bg-gray-300 dark:bg-gray-800 transition-all flex flex-col flex-grow duration-500">
						<div className="container mx-auto h-full">
							<div className="relative flex flex-col min-w-0 break-words bg-white dark:bg-gray-800 transition-all duration-500 w-full h-full">
								{/* Topics */}
								<div>
									<div className="px-6">
										<div className="lg:mt-8">
											{createdTopics.length > 0 ? (
												<div className="mb-20">
													<section className="container mx-auto md:px-4 py-4 lg:px-[7%] px-[3%] mb-3">
														<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
															{isFetching || isLoading ? (
																<LoadingRectanglesAnimation />
															) : (
																createdTopics.map((item: any) => (
																	<TopicCard
																		key={item._id}
																		id={item._id}
																		name={item.name}
																		createdAt={item.createdAt}
																		imagesCount={item.imagesCount}
																		usersCount={item.usersCount}
																		image={item.backgroundImage}
																		creator={{
																			_id: userId,
																			email: email,
																			username: username,
																			photo: photo
																		}}
																		contributors={item.contributors}
																		isContributor={isShowingContributedTopics}
																		tags={item.tags}
																		isComplete={item.isComplete}
																		status={item.reviewStatus}
																		reloadCount={reloadCount}
																		setReloadCount={setReloadCount}
																		topics={createdTopics}
																		setTopics={setCreatedTopics}
																	/>
																))
															)}
														</div>
													</section>
													{isSuccess && data.meta != null && (
														<div className="flex justify-center mt-3">
															<Pagination
																itemsPerPage={data.meta.limit}
																totalCount={data.meta.total}
																totalPages={data.meta.pages}
																currentPage={page}
																setPage={setPage}
															/>
														</div>
													)}
												</div>
											) : (
												<div className="flex flex-col w-8/12 mt-40 mx-auto">
													<h3 className="font-bold text-4xl dark:text-gray-500 text-center">
														You don't have any created topics..
													</h3>
													<h3 className="font-bold text-5xl dark:text-gray-500 text-center mt-1">
														Click on the button below to create your
													</h3>
													<h3 className="font-bold text-6xl dark:text-gray-500 text-center mt-2">
														First Topic
													</h3>

													<button
														className="btn btn-outline btn-sm btn-primary mx-auto mt-8"
														onClick={() => {
															navigate('../add-topic');
														}}
													>
														Create My First Topic ➕
													</button>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</main>
			)}
		</Scrollbars>
	);
}
